import React from 'react';
import { protocol } from '../data/negligence/protocol.js';
import { cover } from '../data/negligence/cover.js';
import { claim } from '../data/negligence/claim.js';
import { defence } from '../data/negligence/defence.js';
import { counsel } from '../data/negligence/counsel.js';
import { strike } from '../data/negligence/strike.js';
import { reply } from '../data/negligence/reply.js';
import { order } from '../data/negligence/order.js';
import { appeal } from '../data/negligence/appeal.js';
import { skeleton } from '../data/negligence/skeleton.js';
import { refuse } from '../data/negligence/refuse.js';
import CarouselSwiper from '../services/CarouselSwiper.jsx';
import '../styles/minute.css';
import '../styles/carousel.css';

const Story = () => {
    return (
        <div className="justified-text">
            <h5>Pre-Action Protocol</h5>
            <p>Before a claim the defendant was put on notice</p>
            <div>
                <br/>
                <CarouselSwiper images={protocol} />
            </div>
            <h5>Covering Letter</h5>
            <p>A covering letter was produced</p>
            <div>
                <br/>
                <CarouselSwiper images={cover} />
            </div>
            <h5>Claim Form & Particulars of Claim</h5>
            <p>A claim form and particulars of claim were produced</p>
            <div>
                <br/>
                <CarouselSwiper images={claim} />
            </div>
            <h5>Defence</h5>
            <p>A defence was produced</p>
            <div>
                <br/>
                <CarouselSwiper images={defence} />
            </div>
            <h5>Strike out application</h5>
            <p>An application for strike out was produced</p>
            <div>
                <br/>
                <CarouselSwiper images={strike} />
            </div>     
            <h5>Reply</h5>
            <p>A direction to join other parties was produced. Also a skeleton argument & reply to a defence</p>
            <div>
                <br/>
                <CarouselSwiper images={reply} />
            </div>   
            <h5>Counsel</h5>
            <p>The court listed a hearing when counsel was not available</p>
            <div>
                <br/>
                <CarouselSwiper images={counsel} />
            </div>
            <h5>Order</h5>
            <p>The judge hearing a strike out made an order</p>
            <div>
                <br/>
                <CarouselSwiper images={order} />
            </div>
            <h5>Permission to appeal</h5>
            <p>Application for permission to appeal</p>
            <div>
                <br/>
                <CarouselSwiper images={appeal} />
            </div>
            <h5>Skeleton arguments</h5>
            <p>Copies of skeleton arguments</p>
            <div>
                <br/>
                <CarouselSwiper images={skeleton} />
            </div>
            <h5>Refuse permission</h5>
            <p>Permission to appeal was refused on a wrong basis. For example that provisions in the Skeleton Argument weren't relied on. That's nonsense.</p>
            <div>
                <br/>
                <CarouselSwiper images={refuse} />
            </div>
        </div>
    );
};

export default Story;
